import { fetchToken } from "../../../common/FetchCookie";
import {
  BASE_URL,
  EMPLOYER,
  EMPLOYER_SUBSCRIPTIONS,
  EMPLOYER_SUBSCRIPTIONS_HISTORY,
  EMPLOYER_SUBSCRIPTIONS_PAYMENT,
} from "../../../common/URLs";

export const fetchEmployerSubscriptions = async () => {
  const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SUBSCRIPTIONS}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    return error
  }
};

// UPDATED: accept page param and return full paginated response
export const fetchEmployerSubscriptionsHistory = async (page = 1) => {
  // Server uses standard Laravel pagination
  const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SUBSCRIPTIONS_HISTORY}?page=${page}`;
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    return error
  }
};

export const fetchEmployerSubscriptionsPaymentCheck = async (uuid) => {
  const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SUBSCRIPTIONS_PAYMENT}/${uuid}`; // Proxy path
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    // console.log("error", error);
    return error
  }
};